import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface FinalizeConfirmModalProps {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function FinalizeConfirmModal({
  show,
  onConfirm,
  onCancel,
}: FinalizeConfirmModalProps): JSX.Element {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Finalize Inventory Run</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to finalize this inventory run?</p>
        <p className="text-muted mb-0">
          The run will be marked as complete.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>Cancel</Button>
        <Button variant="danger" onClick={onConfirm}>Finalize</Button>
      </Modal.Footer>
    </Modal>
  );
}
